var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "px-1 sm:px-12 py-8 font-outfit flex-1" }, [
    _c(
      "div",
      {
        staticClass:
          "flex justify-between items-center mb-4 pb-4 borderMainClientProfile",
      },
      [
        _c("h2", { staticClass: "text-lg font-normal" }, [
          _vm._v("Functional Assessment"),
        ]),
        _c(
          "button",
          {
            staticClass:
              "px-8 py-2 text-16 rounded-full border border-secondary-black hover:bg-gray-50 focus:outline-none",
            on: {
              click: function ($event) {
                return _vm.$emit("edit")
              },
            },
          },
          [_vm._v(" Edit ")]
        ),
      ]
    ),
    _c("div", { staticClass: "flex flex-col gap-5" }, [
      _c("div", { staticClass: "flex gap-8" }, [
        _c("div", { staticClass: "flex-1 text-16 font-medium minWContent" }, [
          _vm._v("Mobility Status"),
        ]),
        _c("div", { staticClass: "flex-2 text-16 font-medium text-gray-400" }, [
          _vm._v(
            " " +
              _vm._s(
                _vm.data.mobility_status ? _vm.data.mobility_status : "N/A"
              ) +
              " "
          ),
          _c("ul", { staticClass: "list-disc pl-5 space-y-1 mt-2" }, [
            _c("li", [
              _vm._v(
                "Level: " +
                  _vm._s(
                    _vm.data.mobility_level ? _vm.data.mobility_level : "N/A"
                  )
              ),
            ]),
            _c("li", [
              _vm._v(
                "Notes: " +
                  _vm._s(
                    _vm.data.mobility_notes ? _vm.data.mobility_notes : "N/A"
                  )
              ),
            ]),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "flex gap-8" }, [
        _c("div", { staticClass: "flex-1 text-16 font-medium minWContent" }, [
          _vm._v("Communication Ability"),
        ]),
        _c("div", { staticClass: "flex-2 text-16 font-medium text-gray-400" }, [
          _vm._v(
            " " +
              _vm._s(
                _vm.data.communication_ability
                  ? _vm.data.communication_ability
                  : "N/A"
              ) +
              " "
          ),
          _c("div", { staticClass: "mt-2" }, [
            _vm._v(
              "Others: " +
                _vm._s(
                  _vm.data.communication_others
                    ? _vm.data.communication_others
                    : "N/A"
                )
            ),
          ]),
          _c("div", { staticClass: "mt-2" }, [
            _vm._v(
              "Notes: " +
                _vm._s(
                  _vm.data.communication_notes
                    ? _vm.data.communication_notes
                    : "N/A"
                )
            ),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "flex gap-8" }, [
        _c("div", { staticClass: "flex-1 text-16 font-medium minWContent" }, [
          _vm._v("Cognitive Status"),
        ]),
        _c("div", { staticClass: "flex-2 text-16 font-medium text-gray-400" }, [
          _c("ul", { staticClass: "list-disc pl-5 space-y-1" }, [
            _c("li", [
              _vm._v(
                "Concerns: " +
                  _vm._s(
                    _vm.data.cognitive_concerns
                      ? _vm.data.cognitive_concerns
                      : "N/A"
                  )
              ),
            ]),
            _c("li", [
              _vm._v(
                "Notes: " +
                  _vm._s(
                    _vm.data.cognitive_notes ? _vm.data.cognitive_notes : "N/A"
                  )
              ),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }